<template>
  <div class="checkout__section card">
    <h4 class="checkout__section-tit">
      Cupom de desconto
    </h4>

    <p class="m-0 p-0 mt-2">
      Se você tem um cupom de desconto, digite e valide abaixo.
    </p>

    <div class="flex items-center justify-start flex-row py-2">
      <input
        v-model="coupon"
        type="text"
        placeholder="Digite o código"
        :disabled="ui.isLoading"
        :class="{ 'cursor-not-allowed': ui.isLoading }"
        class="report__filters-text !w-40"
      >

      <button
        :disabled="ui.isLoading || !coupon"
        class="btn btn-blue ml-3 validate"
        @click="validateCoupon"
      >
        Aplicar
      </button>
    </div>

    <transition
      name="fade"
      mode="out-in"
    >
      <div
        v-if="ui.isValid"
        class="flex flex-row items-center justify-start text-sm text-green"
      >
        <i class="icon icon-check mr-1" />
        cupom aplicado com sucesso
      </div>
    </transition>

    <transition
      name="fade"
      mode="out-in"
    >
      <div
        v-if="ui.isInvalid"
        class="flex flex-row items-center justify-start text-sm text-red"
      >
        <i class="icon icon-cross mr-1" />
        cupom inválido
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'CheckoutCoupon',

  data () {
    return {
      coupon: null,
      ui: {
        isLoading: false,
        isValid: false,
        isInvalid: false
      }
    }
  },

  watch: {
    coupon: {
      deep: false,
      immediate: false,
      handler (str) {
        this.coupon = str.toLocaleUpperCase()
      }
    }
  },

  methods: {
    validateCoupon () {
      const url = '/user/promotional_code_user'
      const data = {
        'code_search': {
          code: this.coupon
        }
      }

      this.ui.isLoading = true
      this.fn_SHOW_PROGRESS()

      this.$http
        .post(url, data, this.$store.getters.getAuthHeader)
        .then(() => {
          this.ui.isValid = true
          this.ui.isInvalid = false
          this.$emit('coupon-activated', true)
        })
        .catch((err) => {
          this.ui.isValid = false
          this.ui.isInvalid = true
          this.fn_HANDLE_ERROR(err)
        })
        .finally(() => {
          this.ui.isLoading = false
          this.fn_HIDE_PROGRESS()
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '$vars';

.checkout {
  &__section {
    @apply p-3 mb-3;
    background: #f4f4f4;

    &-tit {
      color: $color-green;
      font-family: $font1;
      font-size: 1rem;
    }
  }
}

.features {
  @apply list-none m-0 p-0 mx-4;

  &__item {
    @apply flex flex-row items-start justify-start;
    @apply mb-3;
    font-size: 0.7rem;

    i {
      @apply mt-1 mr-2;
    }
  }
}

.validate {
  @apply h-8 m-0 p-0 flex items-center justify-center;
  @apply px-6 py-3 ml-3;
  font-size: 0.7rem;
}
</style>
